export default __webpack_public_path__ + "static/media/CSVFileIcon.0d32e280.svg";